<template>
    <div
        v-if="!hasLoading"
        class="clients"
    >
        <base-card
            v-if="list"
            :addMargins="false"
            class="card--clients"
        >
            <template #card__title >
                <div class="clients__header display--flex">
                    <span class="clients__title capitalize">
                        {{ $t(`global.associates`) }}
                    </span>
                    <div class="clients__actions">
                        <base-export
                            class="clients__actions__export-associates"
                            endpoint="?export=client"
                        >
                            <template #icon>
                                <icon-download />
                            </template>
                        </base-export>
                        <router-link
                            class="clients__actions__new-client position--relative accessibility--pseudo accessibility--active"
                            :to="'/clients/add'">
                            <icon-plus/>
                        </router-link>
                    </div>
                </div>
            </template>
            <template #card__body >
                <base-table
                    v-if="list.length > 0"
                    class="table__clients"
                    :headers="[
                        { name: 'type', canSort: true, filterName: 'type' },
                        { name: 'number', canSort: true, filterName: 'number' },
                        { name: 'fullName', canSort: true, filterName: 'name' },
                        { name: 'profession', canSort: true, filterName: 'profession' }
                    ]"
                    :list="list"
                    :pagination="pagination"
                    model="client"
                    :settings="{
                        component: 'RowClients',
                        warning: $t('global.associates')
                    }"
                />
                <div v-else class="clients__no-results">{{ $t('global.noResults') }}</div>
            </template>
        </base-card>
        <base-pagination
            v-if="pagination"
            class="table__pagination"
            :pagination="pagination"
        />
    </div>
</template>

<script>
// hooks
import { listStructure } from '@/hooks/use-data';

export default {
    ...listStructure,
    components: {
        ...listStructure.components,
        BaseCard: () => import( /* webpackChunkName: 'BaseCard' */ '@/components/bundles/cards/BaseCard' ),
        BasePagination: () => import( /* webpackChunkName: 'Pagination' */ '@/components/bundles/tables/packs/Pagination' ),
        IconPlus: () => import( /* webpackChunkName: 'IconPlus' */ '@/components/bundles/layout/images/icons/IconPlus' ),
        IconDownload: () => import( /* webpackChunkName: 'IconDownload' */ '@/components/bundles/layout/images/icons/IconDownload' ),
        BaseExport: () => import( /* webpackChunkName: 'BaseExport' */ '@/components/bundles/files/BaseExport' )
    },
    props: {
        ...listStructure.props
    }
};
</script>

<style lang="scss" scoped>
    .clients {
        max-width: 1350px;
        margin: 0 auto;
        @include responsive( max-width, 1450px ) {
           margin: 0 45px;
        }
        &__header {
            @include position-grid( center, space-between );
        }
        &__no-results {
            @include typography-specs( 18px, 22px );
            text-align: center;
            padding: 40px 0 20px;
        }
        &__actions {
            &__export-associates {
                margin-right: 10px;
            }
        }
    }
</style>